import React, { useEffect, useState } from 'react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky bar after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-dark border-t border-gold/30 px-5 py-3 flex items-center justify-center gap-4 z-50 shadow-[0_-6px_28px_rgba(0,0,0,0.35)] animate-in slide-in-from-bottom-full duration-300" data-id="element-41">
      <span className="hidden sm:inline text-white/65 text-[13px] font-dmsans" data-id="element-42">
        Kit del Masajista Pro ·{' '}
        <strong className="text-gold-light font-bold" data-id="element-43">$14.999 ARS</strong> ·
        Precio de lanzamiento
      </span>
      <a href="#precio" className="inline-block bg-gradient-to-br from-[#D4A843] to-[#E8A830] text-dark text-sm font-bold px-7 py-3 rounded-md no-underline whitespace-nowrap font-dmsans hover:-translate-y-0.5 transition-transform" data-id="element-44">
        Quiero el Kit →
      </a>
    </div>;
}